function initScrollTogglers() {
    const triggers = document.querySelectorAll('[data-animate-display-class]');
    triggers.forEach(trigger => {
        initScrollToggler(trigger);
    });
}

function initScrollToggler(trigger) {
    const firstToggleId = trigger.getAttribute('data-toggle-on-id');
    const secondToggleId = trigger.getAttribute('data-toggle-off-id');
    const toggleClass = trigger.getAttribute('data-animate-display-class');
    const selectParentSection = trigger.getAttribute('data-select-parent-section') === 'true';

    const targetElement = selectParentSection ? trigger.closest('section') : trigger;
    const firstToggleElement = document.getElementById(firstToggleId);

    if (firstToggleElement) {
        if (firstToggleElement.getBoundingClientRect().y <= 0) {
            targetElement.classList.add(toggleClass);
        } else {
            targetElement.classList.remove(toggleClass);
        }
        const firstObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    targetElement.classList.add(toggleClass);
                } else {
                    if (firstToggleElement.getBoundingClientRect().y > 0) {
                        targetElement.classList.remove(toggleClass);
                    }
                }
            });
        }, {
            threshold: 0,
            rootMargin: `0px`
        });

        firstObserver.observe(firstToggleElement);
    }

    if (secondToggleId) {
        const secondToggleElement = document.getElementById(secondToggleId);
        if (secondToggleElement.getBoundingClientRect().y <= 100) {
            targetElement.classList.remove(toggleClass);
        } else {
            targetElement.classList.add(toggleClass);
        }

        if (secondToggleElement) {
            const secondObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        targetElement.classList.remove(toggleClass);
                    } else {
                        if (secondToggleElement.getBoundingClientRect().y > 100) {
                            targetElement.classList.add(toggleClass);
                        }
                    }
                });
            }, {
                threshold: 0,
                rootMargin: `0px`
            });
    
            secondObserver.observe(secondToggleElement);
        }
    }
}

document.addEventListener('DOMContentLoaded', initScrollTogglers);
